var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#42210A",
    strokeWidth: 1.2,
    d: "M20.107 12.044h-11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.978 18.032 6.21 12.643H4.608l.257.29 4.514 5.103 1.599-.004Z",
    fill: "#42210A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.997 6.002-4.814 5.441H4.581l.284-.32 4.533-5.126 1.6.005Z",
    fill: "#42210A"
  })));
};
export default SvgArrowLeft;